import {
    SET_HEADER_SEARCH_FOCUSED
} from "../actions/siteSearch";

const initialState = {
    isHeaderSearchFocused: false
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case SET_HEADER_SEARCH_FOCUSED:
            return {
                ...state,
                isHeaderSearchFocused: action.isFocused
            };
        default:
            return state;
    }
}

